module.exports = __webpack_public_path__ + "media/חולצה.d28779b6.mp3";